import React from "react";
import classes from "./AdvSec.module.css"
import check from "../../../../img/check.png"
import calibration from "../../../../img/calibration.png"
import proecting from "../../../../img/proecting.png"
import diagnostic from "../../../../img/diagnostic.png"
import repair from "../../../../img/repair.png"

const AdvSec = () => {
    return (
        <div className={classes.advSec}>
            <div className={classes.advContent}>
                <img src={check} alt="Проверка" />
                <img src={calibration} alt="Калибровка" />
                <img src={proecting} alt="Проектирование" />
                <img src={diagnostic} alt="Диагностика" />
                <img src={repair} alt="Ремонт" />
            </div>
        </div>
    )
}

export default AdvSec